import axios, { AxiosRequestConfig } from 'axios';

import { DataResponse } from '../types';
import { ParentSignupVerticalTypeId } from '../types/ParentSignupVerticalType';

const URL = '/v2/admin/qa-seed-user';

type UserType = 'PARENT' | 'SITTER';
type AvailabilityType = 'OCCASIONAL' | 'PART_TIME' | 'FULL_TIME';
type PostFrequency = 'ONE_TIME' | 'PART_TIME' | 'FULL_TIME';

interface SeedUserRequest {
  userType: UserType;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  zip: string;
  phone?: string;
  dob?: string;
  signupVerticalTypeId?: ParentSignupVerticalTypeId;
  availabilityType?: AvailabilityType;
  companyId?: number;
  count?: number;
  createPost?: boolean;
  postDate?: string;
  postFrequency?: PostFrequency;
  postDescription?: string;
  passBackgroundCheck?: boolean;
  passIdentityCheck?: boolean;
}

interface SeededUser {
  userId: number;
  email: string;
  userType: UserType;
}

interface SeedUserResponse {
  users: SeededUser[];
  message: string;
}

class AdminQaSeedUserService {
  static create(
    data: SeedUserRequest,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SeedUserResponse>> {
    return axios.post(URL, data, config);
  }
}

export {
  AdminQaSeedUserService,
  AvailabilityType,
  PostFrequency,
  SeedUserRequest,
  SeedUserResponse,
  SeededUser,
  UserType,
};
